import { render, staticRenderFns } from "./collectPermission.vue?vue&type=template&id=51d2d3b7&scoped=true&"
import script from "./collectPermission.vue?vue&type=script&lang=js&"
export * from "./collectPermission.vue?vue&type=script&lang=js&"
import style0 from "./collectPermission.vue?vue&type=style&index=0&id=51d2d3b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2d3b7",
  null
  
)

component.options.__file = "collectPermission.vue"
export default component.exports